export const sitewideFaqs = [
  {
    q: "What is Beyond the Box?",
    a: "Beyond the Box is the autonomy stack for owner-managed law firms that want more control over operations, compliance, people and growth. It brings together practical tools and support for firms that are done paying for dependency.",
  },
  {
    q: "Who is Beyond the Box for?",
    a: "It is built for owner-managed firms, managing partners, COLPs, COFAs, MLCOs and MLROs who want visibility into how the firm actually runs and do not want to stay trapped inside opaque systems.",
  },
  {
    q: "Is Beyond the Box just another legal-tech platform?",
    a: "No. The point is the opposite. Beyond the Box exists for firms that are tired of being forced into generic legal-tech boxes that do not fit how their teams actually work.",
  },
  {
    q: "Do we need to replace our current systems?",
    a: "Not always. In many firms, the better move is to keep the tools that already do their job well and add a stronger operating and control layer across the top.",
  },
  {
    q: "What problems does Beyond the Box solve?",
    a: "It tackles workflow opacity, software lock-in, spreadsheet drift, fragmented support and the lack of direct owner visibility over what is actually happening inside the firm.",
  },
  {
    q: "Is it only for larger firms?",
    a: "No. It is particularly relevant for owner-managed small and mid-sized firms that need sharper systems and support without building a huge internal infrastructure.",
  },
  {
    q: "Why does autonomy matter for law firms?",
    a: "Because firms should not have to trade control for software. If you cannot properly inspect your workflows, your compliance state or your own data, you are more dependent than you should be.",
  },
];

export const caseminderFaqs = [
  {
    q: "What is CaseMinder?",
    a: "CaseMinder is the bespoke operational and matter-aware workflow layer inside Beyond the Box. It is built to reflect how a firm actually works, not how a vendor thinks firms should behave.",
  },
  {
    q: "How is CaseMinder different from traditional practice management software?",
    a: "Most traditional systems ask the firm to conform to the product. CaseMinder is developed around the firm, its workflows, and the path of least resistance to maximum compliance.",
  },
  {
    q: "Is CaseMinder an all-in-one replacement for every tool we already use?",
    a: "No. The philosophy is best of class, not one bloated box. CaseMinder can sit above strong existing tools and create a better operational spine across them.",
  },
  {
    q: "Can CaseMinder work with Outlook, SharePoint and Teams?",
    a: "Yes. That is a core part of the philosophy. Firms should be able to keep strong tools that already do their job well rather than rip everything out for the sake of a sales pitch.",
  },
  {
    q: "What does bespoke actually mean here?",
    a: "It means the workflows, controls and useful features are shaped around your firm's real operational needs instead of being limited to whatever a generic roadmap happens to allow.",
  },
  {
    q: "What does CaseMinder help owners see?",
    a: "It gives owners and directors clearer visibility over workflow, operational signals, compliance touchpoints, bottlenecks and the way the firm is running day to day.",
  },
  {
    q: "What kind of firm is CaseMinder best for?",
    a: "It is best suited to firms that want serious control, stronger workflow visibility and something closer to a bespoke operating layer than a standard practice-management subscription.",
  },
];

export const complianceminderFaqs = [
  {
    q: "What is ComplianceMinder?",
    a: "ComplianceMinder is a live compliance system for law firms that want policy, registers, remediation and evidence in one inspectable place.",
  },
  {
    q: "Can ComplianceMinder work without CaseMinder?",
    a: "Yes. It is designed to work standalone as well as part of the wider Beyond the Box ecosystem.",
  },
  {
    q: "What does ComplianceMinder manage?",
    a: "It is designed to manage live controlled documents, firmwide risk, registers, remediation and versioned policy change over time.",
  },
  {
    q: "How is this different from spreadsheets and policy folders?",
    a: "Spreadsheets and loose files often drift away from operational reality. ComplianceMinder is built to keep current state, previous state, ownership, approval and remediation visible in one system.",
  },
  {
    q: "Who is it for?",
    a: "It is particularly useful for COLPs, COFAs, MLCOs, MLROs and managing partners who need direct visibility over the firm's real compliance position.",
  },
  {
    q: "Can we use our own policies?",
    a: "Yes. The model is built to support firms bringing their own policies, starting from the Bonsai policy suite, or using a policy review service before upload.",
  },
  {
    q: "Why does version control matter so much?",
    a: "Because law firm compliance is not just about what policy exists today. It is also about what changed, when it changed, who approved it and what evidence exists if scrutiny arrives.",
  },
];

export const electraFaqs = [
  {
    q: "What is Electra HR?",
    a: "Electra HR is the practical people-support layer for firms that need sensible HR support without building an in-house department.",
  },
  {
    q: "When does Electra HR make sense?",
    a: "It makes sense when a firm is growing, dealing with more people issues, or simply wants HR capability without extra headcount and bureaucracy.",
  },
  {
    q: "Is this only relevant to law firms?",
    a: "No, but it is especially useful for law firms and other SMEs that want competent people support without building a full HR function.",
  },
];
